import { Injectable } from '@angular/core';
import { SupabaseService as BaseSupabaseService } from '@examdojo/core/supabase';
import { Subject } from 'rxjs';
import { Database } from './database.types';

@Injectable({
  providedIn: 'root',
})
export class ExamdojoSupabaseService extends BaseSupabaseService<Database> {
  private readonly fatalErrorResponse$$ = new Subject<Response>();
  readonly fatalErrorResponse$ = this.fatalErrorResponse$$.asObservable();

  override getFetch() {
    return async (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
      const response = await fetch(input, init);

      if (this.isFatalResponse(response)) {
        this.fatalErrorResponse$$.next(response);
      }

      return response;
    };
  }

  private isFatalResponse(response: Response) {
    return response.status >= 500 && response.status < 600;
  }
}
